import { AdvancedDynamicTexture } from "@babylonjs/gui/2D/advancedDynamicTexture";
import { Control } from "@babylonjs/gui/2D/controls/control";
import { Rectangle } from "@babylonjs/gui/2D/controls/rectangle";
import { DOMChatBox, DebugBox, MainMenu, Panel_Dialog, Panel_PetStats, Cursor, Watermark } from "./UI";
export class UserInterface {
    constructor(game, entities, currentPlayer) {
        // stub references so Panel base class and MainMenu compile without errors
        this.panelInventory = null;
        this.panelAbilities = null;
        this.panelCharacter = null;
        this.panelHelp = null;
        this.panelQuests = null;
        this._game = game;
        this._scene = game.scene;
        this._engine = game.engine;
        this._room = game.currentRoom;
        this._chatRoom = game.currentChat;
        this._entities = entities;
        this._currentPlayer = currentPlayer;
        this._loadedAssets = game._loadedAssets;
        const LABELS_ADT = AdvancedDynamicTexture.CreateFullscreenUI("UI_Names", true, this._scene);
        this.LABELS_ADT = LABELS_ADT;
        const uiLayer = AdvancedDynamicTexture.CreateFullscreenUI("UI_Player", true, this._scene);
        uiLayer.renderScale = 1;
        this.MAIN_ADT = uiLayer;
        const uiLayerContainer = new Rectangle("uiLayerContainer");
        uiLayerContainer.width = 1;
        uiLayerContainer.height = 1;
        uiLayerContainer.thickness = 0;
        uiLayerContainer.fontFamily = "Arial, sans-serif";
        uiLayerContainer.fontSize = "14px;";
        uiLayer.addControl(uiLayerContainer);
        this._playerUI = uiLayerContainer;
    }
    setCurrentPlayer(currentPlayer) {
        this._currentPlayer = currentPlayer;
        this._Cursor = new Cursor(this);
        this._Watermark = new Watermark(this);
        this._DebugBox = new DebugBox(this._playerUI, this._engine, this._scene, this._room, this._currentPlayer, this._entities);
        this._MainMenu = new MainMenu(this, currentPlayer);
        this._ChatBox = new DOMChatBox(this._playerUI, this._chatRoom, currentPlayer, this._entities, this._game, this._room);
        this.panelDialog = new Panel_Dialog(this, currentPlayer, {
            name: "Dialog Panel",
            width: "350px;",
            height: "400px;",
            top: "-50px;",
            left: "0px;",
            horizontal_position: Control.HORIZONTAL_ALIGNMENT_CENTER,
            vertical_position: Control.VERTICAL_ALIGNMENT_CENTER,
        });
        this._PetStatsPanel = new Panel_PetStats(this._playerUI);
        this.resize();
    }
    // no-op drag stubs — called by Panel base class; no draggable panels are active
    startDragging(_panel) { }
    stopDragging() { }
    update() { }
    slow_update() {
        if (this._DebugBox) {
            this._DebugBox.update();
        }
        if (this.panelDialog) {
            this.panelDialog.update();
        }
        if (this._PetStatsPanel) {
            this._PetStatsPanel.update(this._entities);
        }
    }
    resize() {
        if (this._engine.getRenderWidth() < 1100) {
            if (this._ChatBox) {
                this._ChatBox.chatPanel.top = "-115px;";
            }
        }
        else {
            if (this._ChatBox) {
                this._ChatBox.chatPanel.top = "-30px;";
            }
        }
    }
}
